// DO NOT EDIT -- generated from fs/services/alexa/query_executor.proto

import { QueryCacheOptions } from './search_service_types.proto';

export namespace QueryExecutorPublic {

  export const ReleaseBackgroundRefEndpoint = "/grpc/alexa.QueryExecutorPublic/ReleaseBackgroundRef";
  /** ExecuteQuery executes a query for a single org. */
  export function ReleaseBackgroundRef(sender: (req: ReleaseBackgroundRefRequest, endpoint: string) => Promise<{}>, req: ReleaseBackgroundRefRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ReleaseBackgroundRefEndpoint),
      endpoint: ReleaseBackgroundRefEndpoint
    };
  }
}

export namespace QueryExecutorAdmin {

  export const ClearTasksEndpoint = "/grpc/alexa.QueryExecutorAdmin/ClearTasks";
  /**
   * ClearTasks clears query executor tasks for a single org by issuing a canceled error for queued tasks.
   * Actively running tasks are not affected.
   */
  export function ClearTasks(sender: (req: ClearTasksRequest, endpoint: string) => Promise<ClearTasksResponse>, req: ClearTasksRequest): { promise: () => Promise<ClearTasksResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ClearTasksEndpoint),
      endpoint: ClearTasksEndpoint
    };
  }
}

export interface ReleaseBackgroundRefRequest {
  orgId: string;
  queue: QueryCacheOptions.Queue;
  backgroundRefId: string;
}

export interface ClearTasksRequest {
  orgId: string;
  queue: QueryCacheOptions.Queue;
}

export interface ClearTasksResponse {
  numCleared: number;
}
